module.exports = __webpack_public_path__ + "images/emoji/imp.d80d7e13423a8f6a22d1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/imp.png
// module id = unTz
// module chunks = 2